export default __webpack_public_path__ + "static/media/algoexpert.fa047e58.jpeg";